/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createSelector } from 'reselect'
import { RootState } from '../../store';
import { UserPermissionAccess } from './types';


/** Returns all users */
export const selectUsers = (state: RootState) => state.users.users

/** Returns the current user */
export const selectCurrentUser = (state: RootState) => state.users.currentUser

/** Returns the given user's data */
export const selectUser = createSelector(
  [
    (state: RootState, userId: string) => userId,
    selectUsers
  ],
  (userId, users) => users.find(user => user.id === userId)
)

/** Returns all users with the provided access level to a route */
export const selectUsersWithAccess = createSelector(
  [
    selectUsers,
    (state: RootState, route: string) => route,
    (state: RootState, route: string, access: UserPermissionAccess) => access
  ],
  (users, route, access) => users.filter(user => user.permissions.userArgosRoutePermissions[route] === access)
)


